module.exports = __webpack_public_path__ + "static/img/1ban.918b05a9.png";